import { put, take, fork } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';

import * as actions from 'actions';
import * as api from 'api';

export function* watchForSuccessfullyCreatedFeedback() {
  while(true) { // eslint-disable-line no-constant-condition
    const action = yield take(actions.FEEDBACK_CREATE_SUCCESS);
    yield put(actions.feedbackEditingReset());
    yield put(actions.infoShow('success', action.successMessage));
  }
}

export default function* backgroundSaga(socket, request) {
  yield [
    fork(takeLatest, actions.FEEDBACK_CREATE, request(api.feedbackCreate, 'subject', 'text')),
    fork(watchForSuccessfullyCreatedFeedback)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/sagas.js
 **/